import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * MuiButton
 *
 * Demos:
 *
 * - [Button](https://ui-packages.isbuildingluma.com/ui-core/react-button/)
 *
 * API:
 *
 * - [Button API](https://ui-packages.isbuildingluma.com/ui-core/api/button/)
 * - inherits [MuiButton API](https://mui.com/material-ui/api/button/)
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/N3gFGSM48EkhCahScVFcoK/Luma-Patient-Design-System?node-id=891%3A8995&mode=dev)
 */
const MuiButton = {
  defaultProps: {
    disableFocusRipple: true
  },
  styleOverrides: {
    root: ({
      ownerState,
      theme
    }) => _extends({
      textTransform: 'none',
      borderRadius: 12,
      paddingTop: 10,
      paddingBottom: 10,
      fontFamily: 'Inter',
      boxShadow: 'none !important',
      textAlign: 'center',
      '&.Mui-disabled, &.Mui-disabled:hover': {
        backgroundColor: theme.palette.grey[200],
        border: theme.palette.grey[200],
        color: theme.palette.grey[600]
      },
      '& .MuiSvgIcon-root': {
        width: 20,
        height: 20
      },
      // primary not disabled
      '&:not(.Mui-disabled)': _extends({}, ownerState.variant === 'contained' && ownerState.color === 'primary' && {
        '& .MuiButton-startIcon': {
          color: theme.palette.common.white
        }
      })
    }, ownerState.variant === 'contained' && ownerState.color === 'inherit' && {
      backgroundColor: theme.palette.common.white,
      border: '1px solid',
      borderColor: theme.palette.grey[300],
      '&:hover': {
        backgroundColor: theme.palette.grey[100]
      },
      '&:active': {
        backgroundColor: theme.palette.grey[100]
      },
      '&.Mui-focusVisible': {
        outline: `2px solid ${theme.palette.primary.main}`
      },
      '& .MuiSvgIcon-root': {
        width: 20,
        height: 20,
        color: theme.palette.grey[600]
      }
    }),
    sizeLarge: ({
      theme
    }) => ({
      paddingTop: 12,
      paddingBottom: 12,
      paddingLeft: 24,
      paddingRight: 24,
      lineHeight: theme.typography.pxToRem(24),
      fontSize: theme.typography.pxToRem(16),
      '& .MuiSvgIcon-root': {
        width: 24,
        height: 24
      }
    }),
    sizeSmall: ({
      theme
    }) => ({
      paddingTop: 5,
      paddingBottom: 5,
      paddingLeft: 12,
      paddingRight: 12,
      lineHeight: theme.typography.pxToRem(20),
      '& .MuiSvgIcon-root': {
        width: 16,
        height: 16
      }
    })
  }
};
export default MuiButton;